module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_fails.js
// module id = 64
// module chunks = 0